import MemberShipService from "../../Services/MemberShipService";

export const FETCH_MEMBERSHIP_PLANS_REQUEST = "FETCH_MEMBERSHIP_PLANS_REQUEST";
export const FETCH_MEMBERSHIP_PLANS_SUCCESS = "FETCH_MEMBERSHIP_PLANS_SUCCESS";
export const FETCH_MEMBERSHIP_PLANS_FAILURE = "FETCH_MEMBERSHIP_PLANS_FAILURE";

export const FETCH_MEMBERSHIPS_REQUEST = "FETCH_MEMBERSHIPS_REQUEST";
export const FETCH_MEMBERSHIPS_SUCCESS = "FETCH_MEMBERSHIPS_SUCCESS";
export const FETCH_MEMBERSHIPS_FAILURE = "FETCH_MEMBERSHIPS_FAILURE";

export const fetchMembershipPlans = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_MEMBERSHIP_PLANS_REQUEST });
  try {
    const response = await MemberShipService.getMembershipPlans(payload);
    dispatch({
      type: FETCH_MEMBERSHIP_PLANS_SUCCESS,
      payload: response?.data?.data,
    });
  } catch (error) {
    dispatch({ type: FETCH_MEMBERSHIPS_FAILURE, payload: error.message });
  }
};

export const fetchMemberships = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_MEMBERSHIPS_REQUEST });
  try {
    const response = await MemberShipService.getMemberships(payload);
    dispatch({
      type: FETCH_MEMBERSHIPS_SUCCESS,
      payload: response?.data?.data,
    });
  } catch (error) {
    dispatch({ type: FETCH_MEMBERSHIPS_FAILURE, payload: error.message });
  }
};
